const GROUPING_ROW = "k-grouping-row",
      GROUPCELLCLASS = "k-group-cell";

    function closeRange(entry, footerIndex, lastChildIndex) {
        return {
            headerIndex: entry.headerIndex,
            footerIndex: footerIndex,
            firstChildIndex: entry.headerIndex + 1,
            lastChildIndex: lastChildIndex,
            level: entry.level,
            collapsed: entry.collapsed
        };
    }

    function buildGroupRangeMap(tbody, skipOffset, lockedTbody) {
        skipOffset = skipOffset || 0;
        const ranges = [];
        const stack = [];
        const rows = tbody.children;
        const lockedRows = lockedTbody ? lockedTbody.children : null;
        const rowCount = rows.length;

        for (let i = 0; i < rowCount; i++) {
            const row = rows[i];
            const isGroupHeader = row.classList.contains(GROUPING_ROW);
            const isGroupFooter = row.classList.contains("k-group-footer");
            const globalIndex = skipOffset + i;

            if (isGroupHeader) {
                const levelRow = lockedRows ? lockedRows[i] : row;
                const level = levelRow.querySelectorAll("." + GROUPCELLCLASS).length;
                const collapsed = !!levelRow.querySelector("td[aria-expanded='false']");

                for (let s = stack.length - 1; s >= 0; s--) {
                    if (stack[s].level >= level) {
                        ranges.push(closeRange(stack[s], null, globalIndex - 1));
                        stack.splice(s, 1);
                    }
                }
                stack.push({ headerIndex: globalIndex, level: level, collapsed: collapsed });
            } else if (isGroupFooter) {
                if (stack.length > 0) {
                    const closedHeader = stack.pop();
                    ranges.push(closeRange(closedHeader, globalIndex, globalIndex - 1));
                }
            }
        }

        for (let r = 0; r < stack.length; r++) {
            ranges.push(closeRange(stack[r], null, skipOffset + rowCount - 1));
        }

        const map = {};
        for (let m = 0; m < ranges.length; m++) {
            map[ranges[m].headerIndex] = ranges[m];
        }

        return map;
    }

    function computeStickyHeaderItems(groupRanges, firstVisibleIndex, rawFirstVisibleIndex, allHeaderIndices) {
        const stickyHeaders = [];
        const footerThreshold = rawFirstVisibleIndex !== undefined ? rawFirstVisibleIndex : firstVisibleIndex;
        const bestHeaderPerLevel = new Map();

        for (const range of Object.values(groupRanges)) {
            if (range.collapsed) { continue; }
            if (range.headerIndex < firstVisibleIndex) {
                let groupEnd;
                if (range.footerIndex !== null && allHeaderIndices) {
                    groupEnd = range.footerIndex;
                    for (let h = 0; h < allHeaderIndices.length; h++) {
                        if (allHeaderIndices[h] > range.footerIndex) {
                            groupEnd = allHeaderIndices[h] - 1;
                            break;
                        }
                    }
                } else {
                    groupEnd = range.footerIndex !== null ? range.footerIndex : range.lastChildIndex;
                }
                if (groupEnd > range.headerIndex && groupEnd >= footerThreshold) {
                    const existing = bestHeaderPerLevel.get(range.level);
                    if (!existing || range.headerIndex > existing.headerIndex) {
                        bestHeaderPerLevel.set(range.level, range);
                    }
                }
            }
        }

        const levels = Array.from(bestHeaderPerLevel.keys()).sort((a, b) => a - b);
        for (const lvl of levels) {
            stickyHeaders.push(bestHeaderPerLevel.get(lvl));
        }

        return stickyHeaders;
    }

    function computeStickyFooterItems(groupRanges, lastVisibleIndex) {
        const stickyFooters = [];
        const bestFooterPerLevel = new Map();

        for (const range of Object.values(groupRanges)) {
            if (range.footerIndex === null || range.collapsed) {
                continue;
            }
            if (range.footerIndex > lastVisibleIndex && range.headerIndex <= lastVisibleIndex) {
                const existing = bestFooterPerLevel.get(range.level);
                if (!existing || range.footerIndex < existing.footerIndex) {
                    bestFooterPerLevel.set(range.level, range);
                }
            }
        }

        const levels = Array.from(bestFooterPerLevel.keys()).sort((a, b) => b - a);
        for (const lvl of levels) {
            stickyFooters.push(bestFooterPerLevel.get(lvl));
        }

        return stickyFooters;
    }

    function getStickyRows(containerEl) {
        const wrap = containerEl.querySelector(".k-grid-header-wrap, .k-grid-footer-wrap");
        const tbody = wrap
            ? wrap.querySelector("table > tbody")
            : containerEl.querySelector(":scope > table > tbody");
        return { rows: tbody ? tbody.children : [], heightTarget: containerEl };
    }

    function clearRowTransforms(tr) {
        tr.style.transform = "";
        tr.style.clipPath = "";
        tr.style.display = "";
    }

    function applyHeaderPushTransforms(containerEl, pushOffsets) {
        const { rows: trs, heightTarget } = getStickyRows(containerEl);
        let totalVisibleHeight = 0;
        let hasPush = false;

        for (let i = 0; i < trs.length && i < pushOffsets.length; i++) {
            const tr = trs[i];
            const rowH = tr.getBoundingClientRect().height || tr.offsetHeight;
            const push = pushOffsets[i];

            if (push < 0) {
                hasPush = true;
                const absPush = -push;
                const visibleHeight = Math.max(rowH - absPush, 0);
                totalVisibleHeight += visibleHeight;

                if (visibleHeight <= 0) {
                    tr.style.display = "none";
                    tr.style.transform = "";
                    tr.style.clipPath = "";
                } else {
                    tr.style.display = "";
                    tr.style.transform = `translateY(${push}px)`;
                    tr.style.clipPath = `inset(${absPush}px 0 0 0)`;
                }
            } else {
                totalVisibleHeight += rowH;
                clearRowTransforms(tr);
            }
        }

        if (hasPush) {
            const cs = getComputedStyle(heightTarget);
            const border = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
            heightTarget.style.height = `${Math.max(totalVisibleHeight - border, 0)}px`;
        } else {
            heightTarget.style.height = "";
        }
    }

    function applyFooterPushTransforms(containerEl, pushOffsets) {
        const { rows: trs, heightTarget } = getStickyRows(containerEl);
        let totalVisibleHeight = 0;
        let hasPush = false;
        let totalShrink = 0;
        const rowHeights = [];

        for (let i = 0; i < trs.length && i < pushOffsets.length; i++) {
            const rowH = trs[i].getBoundingClientRect().height || trs[i].offsetHeight;
            rowHeights.push(rowH);
            const push = pushOffsets[i];

            if (push > 0) {
                hasPush = true;
                const visibleH = Math.max(rowH - push, 0);
                totalVisibleHeight += visibleH;
                totalShrink += rowH - visibleH;
            } else {
                totalVisibleHeight += rowH;
            }
        }

        for (let j = 0; j < trs.length && j < pushOffsets.length; j++) {
            const tr = trs[j];
            const pushVal = pushOffsets[j];
            const rH = rowHeights[j];

            if (pushVal > 0) {
                const visible = Math.max(rH - pushVal, 0);
                if (visible <= 0) {
                    tr.style.clipPath = "inset(0 0 100% 0)";
                } else {
                    tr.style.clipPath = `inset(0 0 ${pushVal}px 0)`;
                }
                tr.style.transform = "";
            } else if (hasPush) {
                tr.style.transform = `translateY(${-totalShrink}px)`;
                tr.style.clipPath = "";
            } else {
                clearRowTransforms(tr);
            }
        }

        if (hasPush) {
            const cs = getComputedStyle(heightTarget);
            const border = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
            heightTarget.style.height = `${Math.max(totalVisibleHeight - border, 0)}px`;
        } else {
            heightTarget.style.height = "";
        }
    }

    function resetStickyTransforms(containerEl) {
        const { rows: trs, heightTarget } = getStickyRows(containerEl);
        for (let i = 0; i < trs.length; i++) {
            clearRowTransforms(trs[i]);
        }
        heightTarget.style.height = "";
    }

    function stickyItemsChanged(current, prev) {
        if (current.length !== prev.length) {
            return true;
        }
        for (let i = 0; i < current.length; i++) {
            if (current[i].headerIndex !== prev[i].headerIndex) {
                return true;
            }
        }
        return false;
    }

    function findStickyChildRow(tbody, range, skipOffset, reverse) {
        const start = reverse ? range.lastChildIndex : range.firstChildIndex;
        const end = reverse ? range.firstChildIndex : range.lastChildIndex;
        const step = reverse ? -1 : 1;
        for (let i = start; reverse ? i >= end : i <= end; i += step) {
            const row = tbody.children[i - skipOffset];
            if (row) {
                return row;
            }
        }
        return null;
    }

    function stickyParentPadding(stickyRows, items, range) {
        let padding = 0;
        for (let i = 0; i < items.length; i++) {
            if (items[i].level < range.level) {
                padding += stickyRows[i] ? stickyRows[i].offsetHeight || 36 : 36;
            }
        }
        return padding;
    }

    function buildStickyRowMetrics(tbody, skipOffset) {
        const rows = tbody.children;
        const rowCount = rows.length;
        const rowTops = new Array(rowCount);
        const rowHeightsArr = new Array(rowCount);
        let lastVisibleBottom = 0;

        for (let i = 0; i < rowCount; i++) {
            const h = rows[i].offsetHeight;
            if (h > 0) {
                rowTops[i] = rows[i].offsetTop;
                lastVisibleBottom = rowTops[i] + h;
            } else {
                rowTops[i] = lastVisibleBottom;
            }
            rowHeightsArr[i] = h;
        }

        const totalRowCount = skipOffset + rowCount;

        const getRowHeight = (index) => {
            const local = index - skipOffset;
            return (local >= 0 && local < rowCount) ? rowHeightsArr[local] : 36;
        };

        const getRowOffset = (index) => {
            const local = index - skipOffset;
            if (local >= 0 && local < rowCount) {
                return rowTops[local];
            }
            if (rowCount === 0) {
                return undefined;
            }
            if (local < 0) {
                return rowTops[0] + (local * 36);
            }
            return rowTops[rowCount - 1] + rowHeightsArr[rowCount - 1] + ((local - rowCount) * 36);
        };

        const findFirstVisible = (effectiveTop) => {
            let lo = 0, hi = rowCount;
            while (lo < hi) {
                const mid = (lo + hi) >> 1;
                if (rowTops[mid] + rowHeightsArr[mid] <= effectiveTop) {
                    lo = mid + 1;
                } else {
                    hi = mid;
                }
            }
            return lo < rowCount ? skipOffset + lo : skipOffset;
        };

        const findFirstAtTop = (effectiveTop) => {
            let lo = 0, hi = rowCount;
            while (lo < hi) {
                const mid = (lo + hi) >> 1;
                if (rowTops[mid] < effectiveTop) {
                    lo = mid + 1;
                } else {
                    hi = mid;
                }
            }
            return lo < rowCount ? skipOffset + lo : skipOffset;
        };

        const findLastVisible = (effectiveBottom) => {
            let lo = 0, hi = rowCount - 1;
            while (lo <= hi) {
                const mid = (lo + hi) >> 1;
                if (rowTops[mid] + rowHeightsArr[mid] <= effectiveBottom) {
                    lo = mid + 1;
                } else {
                    hi = mid - 1;
                }
            }
            return hi >= 0 ? skipOffset + hi : skipOffset + rowCount - 1;
        };

        return { getRowHeight, getRowOffset, findFirstVisible, findFirstAtTop, findLastVisible, totalRowCount };
    }

    function convergeStickyHeaders(metrics, groupRanges, scrollTop) {
        const { getRowHeight, getRowOffset, findFirstVisible, findFirstAtTop, totalRowCount } = metrics;

        const rawFirstVisibleIndex = Math.min(findFirstVisible(scrollTop), totalRowCount - 1);
        let stickyHeaderHeight = 0;
        let headerPushOffsets = [];
        let stickyHeaders = [];

        const allHeaderIndices = Object.keys(groupRanges).map(Number).sort((a, b) => a - b);

        const computeHeaderPush = (ranges) => {
            const offsets = [];
            let cumHeight = 0;

            for (let ci = 0; ci < ranges.length; ci++) {
                const range = ranges[ci];
                const rowH = getRowHeight(range.headerIndex);
                let push = 0;

                let boundaryIndex;
                if (range.footerIndex !== null) {
                    boundaryIndex = range.footerIndex + 1;
                    for (let h = 0; h < allHeaderIndices.length; h++) {
                        if (allHeaderIndices[h] > range.footerIndex) {
                            boundaryIndex = allHeaderIndices[h];
                            break;
                        }
                    }
                } else {
                    boundaryIndex = range.lastChildIndex + 1;
                }
                const boundaryOffset = getRowOffset(boundaryIndex);
                if (boundaryOffset !== undefined) {
                    const slotBottom = cumHeight + rowH;
                    const boundaryRelative = boundaryOffset - scrollTop;
                    if (boundaryRelative < slotBottom) {
                        push = boundaryRelative - slotBottom;
                    }
                }

                offsets.push(push);
                cumHeight += Math.max(rowH + push, 0);
            }

            return { totalHeight: cumHeight, offsets };
        };

        const seenFirstVisible = new Set();

        while (true) {
            const firstVisibleIndex = Math.min(
                findFirstAtTop(scrollTop + Math.max(stickyHeaderHeight, 0)),
                totalRowCount - 1
            );

            const isHeaderCycle = seenFirstVisible.has(firstVisibleIndex);
            seenFirstVisible.add(firstVisibleIndex);

            const result = computeStickyHeaderItems(groupRanges, firstVisibleIndex, rawFirstVisibleIndex, allHeaderIndices);
            const headerPush = computeHeaderPush(result);

            const headerConverged =
                !stickyItemsChanged(result, stickyHeaders) &&
                Math.abs(headerPush.totalHeight - stickyHeaderHeight) < 1;

            stickyHeaders = result;
            stickyHeaderHeight = headerPush.totalHeight;
            headerPushOffsets = headerPush.offsets;

            if (headerConverged || isHeaderCycle) {
                break;
            }
        }

        return { items: stickyHeaders, pushOffsets: headerPushOffsets };
    }

    function convergeStickyFooters(metrics, groupRanges, scrollTop, viewportHeight) {
        const { getRowHeight, getRowOffset, findLastVisible, totalRowCount } = metrics;

        let stickyFooterHeight = 0;
        let footerPushOffsets = [];
        let stickyFooters = [];

        const computeFooterPush = (ranges) => {
            const offsets = [];
            let cumHeight = 0;

            for (let ci = ranges.length - 1; ci >= 0; ci--) {
                const range = ranges[ci];
                const rowH = getRowHeight(range.footerIndex);
                let push = 0;

                const boundaryOffset = getRowOffset(range.headerIndex);
                if (boundaryOffset !== undefined) {
                    const boundaryBottom = boundaryOffset + getRowHeight(range.headerIndex);
                    const slotTop = scrollTop + viewportHeight - cumHeight - rowH;
                    if (boundaryBottom > slotTop) {
                        push = boundaryBottom - slotTop;
                    }
                }

                offsets[ci] = push;
                cumHeight += Math.max(rowH - push, 0);
            }

            return { totalHeight: cumHeight, offsets };
        };

        const seenLastVisible = new Set();

        while (true) {
            const effectiveLastVisible = Math.min(
                findLastVisible(scrollTop + viewportHeight - stickyFooterHeight),
                totalRowCount - 1
            );

            const isFooterCycle = seenLastVisible.has(effectiveLastVisible);
            seenLastVisible.add(effectiveLastVisible);

            const footerResult = computeStickyFooterItems(groupRanges, effectiveLastVisible);
            const footerPush = computeFooterPush(footerResult);

            const footerConverged =
                !stickyItemsChanged(footerResult, stickyFooters) &&
                Math.abs(footerPush.totalHeight - stickyFooterHeight) < 1;

            stickyFooters = footerResult;
            stickyFooterHeight = footerPush.totalHeight;
            footerPushOffsets = footerPush.offsets;

            if (footerConverged || isFooterCycle) {
                break;
            }
        }

        return { items: stickyFooters, pushOffsets: footerPushOffsets };
    }

    function syncColgroup(targetTable, sourceTable) {
        if (!targetTable) {
            return;
        }
        const existing = targetTable.querySelector(":scope > colgroup");
        const source = sourceTable.querySelector(":scope > colgroup");
        if (source) {
            const sourceCols = source.children;
            if (existing && existing.children.length === sourceCols.length) {
                const targetCols = existing.children;
                for (let i = 0; i < sourceCols.length; i++) {
                    const w = sourceCols[i].style.width;
                    if (w) {
                        if (targetCols[i].style.width !== w) {
                            targetCols[i].style.width = w;
                        }
                    } else if (targetCols[i].style.width) {
                        targetCols[i].style.width = "";
                    }
                }
            } else {
                if (existing) {
                    existing.remove();
                }
                targetTable.prepend(source.cloneNode(true));
            }
        } else if (existing) {
            existing.remove();
        }
        targetTable.style.width = sourceTable.style.width || sourceTable.getBoundingClientRect().width + "px";
    }

    function renderStickyRowsHtml(sourceRows, items, indexProp, skipOffset) {
        let html = "";
        for (let i = 0; i < items.length; i++) {
            const row = sourceRows[items[i][indexProp] - skipOffset];
            if (row) {
                html += `<tr class='${row.className}'>${row.innerHTML}</tr>`;
            }
        }
        return html;
    }

    const STICKY_CONTAINER_CLASS = "k-grid-sticky-container";

    function createStickyTable(tableClass, sizeClass) {
        const table = document.createElement("table");
        table.className = tableClass + " k-grid-table k-table" + (sizeClass ? " " + sizeClass : "");
        const tbody = document.createElement("tbody");
        tbody.className = "k-table-tbody";
        table.appendChild(tbody);
        return table;
    }

    function createStickyGroupContainer(tableClass, sizeClass, extraClasses) {
        const div = document.createElement("div");
        div.className = STICKY_CONTAINER_CLASS + (extraClasses ? " " + extraClasses : "");
        div.setAttribute("aria-hidden", "true");
        const table = createStickyTable(tableClass, sizeClass);
        div.appendChild(table);
        return { container: div, table: table };
    }

    function createStickyGroupLockedContainer(tableClass, sizeClass) {
        const div = document.createElement("div");
        div.className = "k-grid-content-locked";
        const table = createStickyTable(tableClass, sizeClass);
        div.appendChild(table);
        return { container: div, table: table };
    }

    export {
        buildGroupRangeMap,
        computeStickyHeaderItems,
        computeStickyFooterItems,
        applyHeaderPushTransforms,
        applyFooterPushTransforms,
        resetStickyTransforms,
        stickyItemsChanged,
        findStickyChildRow,
        stickyParentPadding,
        buildStickyRowMetrics,
        convergeStickyHeaders,
        convergeStickyFooters,
        syncColgroup,
        renderStickyRowsHtml,
        createStickyGroupContainer,
        createStickyGroupLockedContainer
    };
